/**
 * @generated SignedSource<<fb90ef56eabbc61a883f5e74c62e4110>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CloudApiHealthStatusHealthStatusEnum = "GREEN" | "RED" | "UNKNOWN" | "YELLOW" | "%future added value";
export type unlinkDeviceFromOrganizationMutation$variables = {
  deviceNodeId: string;
};
export type unlinkDeviceFromOrganizationMutation$data = {
  readonly unlinkDeviceFromOrganization: {
    readonly accessPoint: {
      readonly deviceHealthStatus: CloudApiHealthStatusHealthStatusEnum | null;
      readonly displayName: string;
      readonly id: string;
      readonly organization: {
        readonly id: string;
      } | null;
    } | null;
    readonly attachment: {
      readonly deviceHealthStatus: CloudApiHealthStatusHealthStatusEnum | null;
      readonly displayName: string | null;
      readonly id: string;
      readonly organization: {
        readonly id: string;
      } | null;
    } | null;
    readonly battery: {
      readonly deviceHealthStatus: CloudApiHealthStatusHealthStatusEnum | null;
      readonly displayName: string | null;
      readonly id: string;
      readonly organization: {
        readonly id: string;
      } | null;
    } | null;
    readonly controller: {
      readonly deviceHealthStatus: CloudApiHealthStatusHealthStatusEnum | null;
      readonly displayName: string | null;
      readonly id: string;
      readonly organization: {
        readonly id: string;
      } | null;
    } | null;
    readonly dock: {
      readonly deviceHealthStatus: CloudApiHealthStatusHealthStatusEnum | null;
      readonly displayName: string;
      readonly id: string;
      readonly organization: {
        readonly id: string;
      } | null;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
    readonly gimbal: {
      readonly deviceHealthStatus: CloudApiHealthStatusHealthStatusEnum | null;
      readonly displayName: string | null;
      readonly id: string;
      readonly organization: {
        readonly id: string;
      } | null;
    } | null;
    readonly sensor: {
      readonly displayName: string | null;
      readonly id: string;
      readonly organization: {
        readonly id: string;
      } | null;
    } | null;
    readonly vehicle: {
      readonly deviceHealthStatus: CloudApiHealthStatusHealthStatusEnum | null;
      readonly displayName: string;
      readonly id: string;
      readonly organization: {
        readonly id: string;
      } | null;
    } | null;
  } | null;
};
export type unlinkDeviceFromOrganizationMutation = {
  response: unlinkDeviceFromOrganizationMutation$data;
  variables: unlinkDeviceFromOrganizationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceNodeId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "deviceHealthStatus",
    "storageKey": null
  },
  (v3/*: any*/)
],
v5 = [
  {
    "alias": "unlinkDeviceFromOrganization",
    "args": [
      {
        "kind": "Variable",
        "name": "deviceNodeId",
        "variableName": "deviceNodeId"
      }
    ],
    "concreteType": "UnclaimDevice",
    "kind": "LinkedField",
    "name": "unclaimDevice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccessPoint",
        "kind": "LinkedField",
        "name": "accessPoint",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Attachment",
        "kind": "LinkedField",
        "name": "attachment",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Battery",
        "kind": "LinkedField",
        "name": "battery",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Controller",
        "kind": "LinkedField",
        "name": "controller",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Dock",
        "kind": "LinkedField",
        "name": "dock",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Sensor",
        "kind": "LinkedField",
        "name": "sensor",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Vehicle",
        "kind": "LinkedField",
        "name": "vehicle",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Gimbal",
        "kind": "LinkedField",
        "name": "gimbal",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "unlinkDeviceFromOrganizationMutation",
    "selections": (v5/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "unlinkDeviceFromOrganizationMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "cbc0344cdcde3bd7295eb3eb5109fc34",
    "id": null,
    "metadata": {},
    "name": "unlinkDeviceFromOrganizationMutation",
    "operationKind": "mutation",
    "text": "mutation unlinkDeviceFromOrganizationMutation(\n  $deviceNodeId: ID!\n) {\n  unlinkDeviceFromOrganization: unclaimDevice(deviceNodeId: $deviceNodeId) {\n    accessPoint {\n      id\n      displayName\n      deviceHealthStatus\n      organization {\n        id\n      }\n    }\n    attachment {\n      id\n      displayName\n      deviceHealthStatus\n      organization {\n        id\n      }\n    }\n    battery {\n      id\n      displayName\n      deviceHealthStatus\n      organization {\n        id\n      }\n    }\n    controller {\n      id\n      displayName\n      deviceHealthStatus\n      organization {\n        id\n      }\n    }\n    dock {\n      id\n      displayName\n      deviceHealthStatus\n      organization {\n        id\n      }\n    }\n    sensor {\n      id\n      displayName\n      organization {\n        id\n      }\n    }\n    vehicle {\n      id\n      displayName\n      deviceHealthStatus\n      organization {\n        id\n      }\n    }\n    gimbal {\n      id\n      displayName\n      deviceHealthStatus\n      organization {\n        id\n      }\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "170acaf8129be507d4bc4070189b9a8a";

export default node;
